import React, { useState, useRef, ReactElement } from 'react';
import { IonIcon, IonBadge } from '@ionic/react';
import { chatbubbleEllipsesSharp } from 'ionicons/icons';
import { useButton } from '@react-aria/button';

export const PromptCommentButton: React.FC<{
  togglePromptComments: () => void;
}> = ({ togglePromptComments }): ReactElement => {
  const BUTTON_LABEL = 'View comments';

  const CommentButton = (props: any) => {
    const { children } = props;
    const commentButtonRef = useRef<HTMLButtonElement>(null);
    const { buttonProps } = useButton(props, commentButtonRef);
    return (
      <button
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...buttonProps}
        ref={commentButtonRef}
        title={BUTTON_LABEL}
        type="button"
        className="btn"
        tabIndex={0}
      >
        {children}
      </button>
    );
  };

  return (
    <div className="btn-wrapper">
      <CommentButton onPress={togglePromptComments} aria-label={BUTTON_LABEL}>
        <IonIcon aria-hidden="true" icon={chatbubbleEllipsesSharp} />
      </CommentButton>
    </div>
  );
};
